module.exports = __webpack_public_path__ + "img/tabbar_lightskin_slider.23d39a05.png";